import { createAuthService } from './authServiceFactory';

export default createAuthService('pge-token');
